<template>
  <SimpleDictView
    endpoint="warehouse/meal-types/"
    :title="$t('settings.titles.mealTypes')"
    :add-button="$t('settings.addButtons.mealType')"
    :fields="fields"
  />
</template>
<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'MealTypesView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [{ key: 'name', label: this.$t('settings.fields.name'), placeholder: this.$t('settings.placeholders.mealTypeName') }]
    },
  },
}
</script>
